import React from "react";

import map from "lodash/map";

const VerticalListWithoutTitle = ({ list, history, onClose }) => {
  return (
    <ul className="vertical-navdropdown-without-title">
      {map(list, item => (
        <li>
          <a
            href={item.href}
            onClick={e => {
              e.preventDefault();
              history.push(item.href);
              onClose();
            }}
          >
            {item.title}
          </a>
        </li>
      ))}
    </ul>
  );
};

VerticalListWithoutTitle.defaultProps = {
  list: [
    {
      href: "/recipes",
      title: "Most Popular"
    },
    {
      href: "/recipes",
      title: "BLD Plans"
    },
    {
      href: "/recipes",
      title: "Gluten Free"
    },
    {
      href: "/recipes",
      title: "6 Ingredient"
    },
    {
      href: "/recipes",
      title: "Kid Friendly"
    }
  ]
};

export default VerticalListWithoutTitle;
